import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-reject-modal-qc',
  templateUrl: './reject-modal-qc.component.html',
  styleUrls: ['./reject-modal-qc.component.sass'],
})
export class RejectModalQcComponent {
  selectedErrors: number[] = [];
  errorTypes = [
    { id: 1, description: 'Tela' },
    { id: 2, description: 'Carcaça' },
    { id: 3, description: 'Botões' },
    { id: 4, description: 'Bateria' },
    { id: 5, description: 'Bloqueado' },
  ];

  constructor(
    public dialogRef: MatDialogRef<RejectModalQcComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onCancel(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    this.dialogRef.close(this.selectedErrors);
  }
}
